/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentid200,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentid400,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentid401,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentid404,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentid500,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentidMutationRequest,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentidMutationResponse,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentidPathParams,
  PostApiV1PecegepayCreditcardCoursefinpersonpaymentidQueryParams,
} from "../../types/pecegePayCreditCardController/PostApiV1PecegepayCreditcardCoursefinpersonpaymentid.ts";
import { creditCardLimitRequestViewModelSchema } from "../creditCardLimitRequestViewModelSchema.ts";
import { creditCardOrderResponseViewModelSchema } from "../creditCardOrderResponseViewModelSchema.ts";
import { eFinancialOrderLogTypeSchema } from "../eFinancialOrderLogTypeSchema.ts";

export const postApiV1PecegepayCreditcardCoursefinpersonpaymentidPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentidPathParams>;

export const postApiV1PecegepayCreditcardCoursefinpersonpaymentidQueryParamsSchema =
  z
    .object({
      recurrenceToken: z.optional(z.string()),
      source: z.optional(
        z
          .lazy(() => eFinancialOrderLogTypeSchema)
          .describe(
            "0 = Undefined | 1 = CreditCardCreationTreasuryStudent | 2 = CreditCardLimitTreasuryStudent | 3 = CreditCardLimitIndividualPaymnent | 4 = CreditCardLimitEnrollment | 5 = BilletEnrollment | 6 = BilletTreasuryStudent | 7 = BilletIndividualPaymnent | 8 = BilletWebhookReturn | 9 = CreditCardWebhookReturn | 10 = CreditCardRecurrence | ",
          ),
      ),
      Installments: z.optional(z.coerce.number().int()),
      StatementDescriptor: z.optional(z.string()),
      MerchantIdentifier: z.optional(z.string()),
      Version: z.optional(z.string()),
      Signature: z.optional(z.string()),
      "IntermediateSigningKey.SignedKey": z.optional(z.string()),
      "IntermediateSigningKey.Signatures": z.optional(z.array(z.string())),
      SignedMessage: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PecegepayCreditcardCoursefinpersonpaymentid200Schema =
  z.lazy(
    () => creditCardOrderResponseViewModelSchema,
  ) as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PecegepayCreditcardCoursefinpersonpaymentid400Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PecegepayCreditcardCoursefinpersonpaymentid401Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PecegepayCreditcardCoursefinpersonpaymentid404Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PecegepayCreditcardCoursefinpersonpaymentid500Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentid500>;

export const postApiV1PecegepayCreditcardCoursefinpersonpaymentidMutationRequestSchema =
  z.lazy(
    () => creditCardLimitRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentidMutationRequest>;

export const postApiV1PecegepayCreditcardCoursefinpersonpaymentidMutationResponseSchema =
  z.lazy(
    () => postApiV1PecegepayCreditcardCoursefinpersonpaymentid200Schema,
  ) as unknown as ToZod<PostApiV1PecegepayCreditcardCoursefinpersonpaymentidMutationResponse>;
